import { render, staticRenderFns } from "./ModalsConfirmAssingConsultant.vue?vue&type=template&id=7876a491&scoped=true"
import script from "./ModalsConfirmAssingConsultant.vue?vue&type=script&lang=js"
export * from "./ModalsConfirmAssingConsultant.vue?vue&type=script&lang=js"
import style0 from "./ModalsConfirmAssingConsultant.vue?vue&type=style&index=0&id=7876a491&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7876a491",
  null
  
)

export default component.exports